export default __webpack_public_path__ + "static/rombo-pink-29e4d51a1251667c3861e5c3d7dc1228.png";